import {
  FetchResult,
  MutationFunctionOptions,
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
} from "@apollo/client";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { DocumentNode } from "graphql";
import { useState } from "react";
import useMutation from "utils/useMutation";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebouncedMutation = <TData = any, TVariables = OperationVariables>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: MutationHookOptions<TData, TVariables>,
  timeout = 500
): MutationTuple<TData, TVariables> => {
  const [timeoutRef, setTimeoutRef] = useState<NodeJS.Timer>();
  const [mutate, mutationData] = useMutation<TData, TVariables>(
    mutation,
    options
  );

  const debounced = (
    wrappedOptions?: MutationFunctionOptions<TData, TVariables>
  ) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Promise<FetchResult<TData, Record<string, any>, Record<string, any>>>(
      (resolve) => {
        if (timeoutRef) {
          clearTimeout(timeoutRef);
        }
        setTimeoutRef(
          setTimeout(() => {
            resolve(mutate(wrappedOptions));
          }, timeout)
        );
      }
    );

  return [debounced, mutationData];
};

export default useDebouncedMutation;
